import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../../services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-study-team-organization-view-modal',
  templateUrl: './ist-study-team-organization-view-modal.component.html',
  styleUrls: ['./ist-study-team-organization-view-modal.component.scss']
})
export class IstStudyTeamOrganizationViewModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  departments = departmentsOptionsConstant;
  organisationType: any[];
  organisationSubType: any[];
  studyTeamOrganizationForm: UntypedFormGroup;
  ApplicationID: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  staticformFields: any;

  currencyOptions = currencyOptionsConstant;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    public datashareService: IstDataShareService,
    public commonService: CommonService,
    private modalService: NgbModal,

  ) {
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-003');
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.studyTeamOrganizationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(null),
      SUB_TYPE: new UntypedFormControl(null),
      WEB_SITE: new UntypedFormControl("", [Validators.required]),
      ADDRESS: new UntypedFormControl("", [Validators.required]),
      PHONE: new UntypedFormControl("", [Validators.maxLength(20), Validators.required])
    });
    this.getMasterData();
    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.getOrganizationData();
    }
  }

  getMasterData() {
    this.organisationType = [];
    this.organisationSubType = [];
    this.summaryService.getSummaryData('api/ISTOrganization/GetMasterData?ApplicationID=' + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      this.organisationType = [{ label: "Select", value: "", checked: true }].concat(this.organisationType);
      this.organisationSubType = summary["MasterData2"];
      this.organisationSubType = [{ label: "Select", value: "", checked: true }].concat(this.organisationSubType);
    });
  }

  getOrganizationData() {
    this.summaryService.getSummaryData('api/ISTOrganization/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
      if (summary != null) {
        this.studyTeamOrganizationForm.patchValue({
          ID: summary["ID"],
          APPLICATION_ID: summary["APPLICATION_ID"],
          NAME: summary["NAME"],
          TYPE: summary["TYPE"],
          SUB_TYPE: summary["SUB_TYPE"],
          WEB_SITE: summary["WEB_SITE"],
          ADDRESS: summary["ADDRESS"],
          PHONE: summary["PHONE"]
        });
      }

      if (this.Content.heading == "View") {
        this.studyTeamOrganizationForm.disable();
      }

    });
  }

  SaveISTOrganization() {

    if (this.validateControls()) {
      var formData = this.studyTeamOrganizationForm.value;

      formData.APPLICATION_ID = this.ApplicationID;
      formData.RECORD_STATE = parseInt("0");
      formData.CREATED_DATE = new Date();
      formData.LAST_UPDATED_DATE = new Date();
      if (this.Content.heading == "Add") {
        this.summaryService.Insert('api/ISTOrganization/Insert', formData).subscribe(summary => {
          if (summary.Status === 0) {
            this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result1 => {
              if (result1.Status === 0) {

                this.modalRef.close();
                this.commonService.SuccessBanner(summary.Message);
              }
              else
                this.commonService.ValidationBanner(result1.Message);
            });
          }
          else {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
      else {
        this.summaryService.getAppSubmitValidations("api/ISTOrganization/IST_APPInActiveORGValidation?TypeId=" + formData.TYPE + "&SubTypeId=" + formData.SUB_TYPE
          // + "&PkId=" + formData["ID"]
        ).subscribe((resultInactive) => {
          if (resultInactive != null && resultInactive != undefined) {
            if (resultInactive.Status == 0) {
              let dataMsg = resultInactive.Data.Validations[0].FiledsData.join("</br>");
              this.commonService.ValidationBanner(dataMsg);
            }
            else {
              this.summaryService.Insert('api/ISTOrganization/Update', formData).subscribe(summary => {
                if (summary.Status === 0 || summary.ErrorCode === "NOCHANGES") {
                  this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result1 => {
                    if (result1.ErrorCode === "NOCONTROLS") {
                      if (summary.Status === 0)
                      {
                        this.commonService.SuccessBanner(summary.Message);
                        this.modalRef.close();
                      }
                      else {
                        this.commonService.ValidationBanner(summary.Message);
                      }
                    }
                    else {
                      if (summary.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                        this.commonService.ValidationBanner(summary.Message);
                      }
                      else {
                        this.commonService.SuccessBanner(formData["NAME"] + " Details updated successfully");
                        this.modalRef.close();
                      }
                    }
                  });
                }
                else {
                  this.commonService.ValidationBanner(summary.Message);
                }

              });
            }
          }
        });
      }
    }
  }

  CancelPopUp() {
    this.modalRef.close();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyTeamOrganizationForm.value;

    if (this.staticformFields?.NAME.IS_Display && this.staticformFields?.NAME.IS_MANDATORY) {
      if (formData.NAME === null || formData.NAME === "") {
        $("#NAME").addClass("ng-touched ng-invalid validate-error");
        $("#NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#NAME").addClass("ng-untouched ng-valid");
        $("#NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TYPE.IS_Display && this.staticformFields?.TYPE.IS_MANDATORY) {
      if (formData.TYPE === null || formData.TYPE === "") {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TYPE.IS_Display && this.staticformFields?.SUB_TYPE.IS_Display && this.staticformFields?.SUB_TYPE.IS_MANDATORY) {
      if (formData.SUB_TYPE === null || formData.SUB_TYPE === "") {
        $("#SUB_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#SUB_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.SUB_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#SUB_TYPE").addClass("ng-untouched ng-valid");
        $("#SUB_TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.WEB_SITE.IS_Display && this.staticformFields?.WEB_SITE.IS_MANDATORY) {
      if (formData.WEB_SITE === null || formData.WEB_SITE === "") {
        $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#WEB_SITE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.WEB_SITE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
        if (formData.WEB_SITE.match(website)) {
          $("#WEB_SITE").addClass("ng-untouched ng-valid");
          $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
          $("#WEB_SITE").removeClass("ng-untouched ng-valid");
          message += `Please enter valid ${this.staticformFields?.WEB_SITE.LABEL_NAME} <br/>`;
          isValid = false;
        }
      }
    }

    if (this.staticformFields?.ADDRESS.IS_Display && this.staticformFields?.ADDRESS.IS_MANDATORY) {
      if (formData.ADDRESS === null || formData.ADDRESS === "") {
        $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
        $("#ADDRESS").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ADDRESS.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ADDRESS").addClass("ng-untouched ng-valid");
        $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PHONE.IS_Display && this.staticformFields?.PHONE.IS_MANDATORY) {
      if (formData.PHONE === null || formData.PHONE === "" || formData.PHONE == undefined) {
        $("#PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PHONE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PHONE").addClass("ng-untouched ng-valid");
        $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs; //this.extendedForm.validateControlsMsgs();
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

}
